import { HTMLAttributes, ReactNode } from 'react';
import { Layout } from 'antd';

const { Content } = Layout;
interface MainProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const Main = ({ children, ...rest }: MainProps) => {
  return (
    <Layout>
      <Content
        style={{
          padding: 24,
          minHeight: 280,
          margin: "24px 16px 0", overflow: "initial"
        }}
      >
        {children}
      </Content>
    </Layout>
  );
};

export default Main;
